import {
  createGameStateUpdater,
  joinGameStateUpdater,
  systemsStateUpdater,
  tokenUpdater,
  userChangeUpdater,
  voteChangeUpdater,
  timerChangeUpdater,
  voteRevealUpdater,
  newVotingUpdater,
  gameSummaryUpdater,
  taskUpdater,
} from "./game.updaters";
import { ActionTypes } from "./game.reducer.types";
import {
  CreateGameResponse,
  JoinToGameResponse,
  VoteResponse,
  SystemsResponse,
} from "../socket/socket.responses";
import { GameStateModel } from "../models/game/gameState.model";
import { UserChangeModel } from "../socket/events/UserChange/userChange.model";
import { VoteChangeModel } from "../socket/events/VoteChange/voteChange.model";
import { TimerChangeModel } from "../socket/events/TimerChange/timerChange.model";
import { TaskModel } from "../models/task/task.model";
import { VoteRevealModel } from "../socket/events/VoteReveal/voteReveal.model";
import { GameModel } from "../models/game/game.model";

export type GameActions =
  | {
      type: ActionTypes.CREATE;
      data: CreateGameResponse;
    }
  | {
      type: ActionTypes.JOIN;
      data: JoinToGameResponse;
    }
  | {
      type: ActionTypes.VOTE;
      data: VoteResponse;
    }
  | {
      type: ActionTypes.GET_SYSTEMS;
      data: SystemsResponse;
    }
  | {
      type: ActionTypes.SET_TOKEN;
      data: {
        token: string | null;
      };
    }
  | {
      type: ActionTypes.USER_CHANGE;
      data: UserChangeModel;
    }
  | {
      type: ActionTypes.VOTE_CHANGE;
      data: VoteChangeModel;
    }
  | {
      type: ActionTypes.TIMER_CHANGE;
      data: TimerChangeModel;
    }
  | {
      type: ActionTypes.VOTE_REVEAL;
      data: VoteRevealModel;
    }
  | {
      type: ActionTypes.NEW_VOTING;
      data: GameModel;
    }
  | {
      type: ActionTypes.GAME_SUMMARY;
      data: TaskModel[];
    }
  | {
      type: ActionTypes.TASK_LIST_UPDATE;
      data: {
        selectedTaskId: string;
        tasks: TaskModel[];
      }
    }

export const gameReducer = (
  state: GameStateModel,
  action: GameActions
): GameStateModel => {
  const {
    CREATE,
    JOIN,
    GET_SYSTEMS,
    SET_TOKEN,
    USER_CHANGE,
    VOTE_CHANGE,
    TIMER_CHANGE,
    VOTE_REVEAL,
    NEW_VOTING,
    GAME_SUMMARY,
    TASK_LIST_UPDATE,
  } = ActionTypes;
  switch (action.type) {
    case CREATE:
      return createGameStateUpdater(state, action.data);
    case JOIN:
      return joinGameStateUpdater(state, action.data);
    case GET_SYSTEMS:
      return systemsStateUpdater(state, action.data);
    case SET_TOKEN:
      return tokenUpdater(state, action.data);
    case USER_CHANGE:
      return userChangeUpdater(state, action.data);
    case VOTE_CHANGE:
      return voteChangeUpdater(state, action.data);
    case TIMER_CHANGE:
      return timerChangeUpdater(state, action.data);
    case VOTE_REVEAL:
      return voteRevealUpdater(state, action.data);
    case NEW_VOTING:
      return newVotingUpdater(state, action.data);
    case GAME_SUMMARY:
      return gameSummaryUpdater(state, action.data);
    case TASK_LIST_UPDATE:
      return taskUpdater(state, action.data);
    default:
      return state;
  }
};
